const ORCHESTRATOR_AGENT_PATTERN = /orchestrator agent/i;

const SECTION_WITH_PROMPT =
  /Prompt:<br>\s*<b>Agent:<\/b>\s*([A-Za-z\s]+?)<br>[\s\S]*?(?=(?:<br>\s*)?Prompt:<br>|$)/gi;
const SECTION_WITH_AGENT_ONLY =
  /<b>Agent:<\/b>\s*([A-Za-z\s]+?)<br>[\s\S]*?(?=<b>Agent:<\/b>|$)/gi;
const MARKDOWN_SECTION_REGEX =
  /(?:\n{0,2}---\n\n)?###\s+Agent:\s*([^\n]+)\n[\s\S]*?(?=(?:\n{0,2}---\n\n)?###\s+Agent:|\s*$)/gi;

const stripSection = (pattern: RegExp, input: string) =>
  input.replace(pattern, (match, agentName = '') =>
    ORCHESTRATOR_AGENT_PATTERN.test(agentName) ? '' : match,
  );

/**
 * Removes Orchestrator-agent sections from the thought process content so the final response
 * is not duplicated in the UI. Supports both legacy HTML-formatted strings and the new Markdown
 * representation emitted by the backend.
 */
export const stripOrchestratorAgentSections = (content: string): string => {
  if (!content) return content;

  let sanitized = stripSection(SECTION_WITH_PROMPT, content);
  sanitized = stripSection(SECTION_WITH_AGENT_ONLY, sanitized);
  sanitized = stripSection(MARKDOWN_SECTION_REGEX, sanitized);

  return sanitized.trim();
};
